import { sendEvent } from '@nubank/www-latam-commons/services/analytics';

export const triggerOptimize = () => sendEvent('optimize.activate');
